import React, { useState } from 'react';
import { useTaskOptions } from './hooks/useTaskOptions.js';
import styles from './Task.module.scss';

const btnStyle = {maxHeight: 33};

function TaskListBase({ projectId, children, views = ['list', 'kanban'] }) {
  const [groupingValue, setGroupingValue] = useState('tasks');
  const [activeView, setActiveView] = useState('list');
  const [presetId, setPresetId] = useState(null);
  const [ganttScale, setGanttScale] = useState('week');
  const [ganttView, setGanttView] = useState('panel_on');
  
  const options = useTaskOptions({ projectId });
  return <div className={`${styles['task-list-base']} ${styles[`show-${activeView}`]}`}>
    {children({
      btnStyle,
      options,
      presetId: presetId || null,
      setPresetId,
      groupGridItems: groupingValue === 'work_packages',
      gridGroupToggleProps: {
        btnStyle: btnStyle,
        items: [
          { value: 'tasks', label: I18n.t('tasks') },
          { value: 'work_packages', label: I18n.t('work_packages') },
        ],
        value: groupingValue,
        onChange: setGroupingValue
      },
      activeView,
      listKanbanToggleProps: {
        btnStyle: btnStyle,
        items: views.map(view => ({ value: view, label: I18n.t(view) })),
        value: activeView,
        onChange: setActiveView
      },
      ganttView,
      ganttViewToggleProps: {
        btnStyle: btnStyle,
        items: [
          {value: 'panel_on', label: I18n.t('panel_on')},
          {value: 'panel_off', label: I18n.t('panel_off')}
        ],
        value: ganttView,
        onChange: setGanttView
      },
      ganttScale,
      ganttScaleToggleProps: {
        btnStyle: btnStyle,
        items: [
          {value: 'day', label: I18n.t('day')},
          {value: 'week', label: I18n.t('week')},
          {value: 'month', label: I18n.t('month')}
        ],
        value: ganttScale,
        onChange: setGanttScale
      },
    })}
  </div>;
}

export default TaskListBase;
